
//#region Helper Imports

import { DataProvider } from "../helpers"
import { DashboardComponent } from "../helpers/dashboard-component"
import { DataProviderRequest } from "./utils"

//#endregion

//#region Model Imports

import { Enums } from "../models/common"
import { OpDashboard, OpDashboardControl } from "../models/custom"
import { OpExportData } from "../models/util"
import { OpFile } from "../models/core"

//#endregion

//#region Util Imports

import * as _ from 'underscore'

//#endregion

export class DataProviderDashboard {

    // #region Ctor

    constructor(private readonly dataProvider: DataProvider) { }

    // #endregion

    //#region Delete

    public deleteDashboard = (idOperator: number, dashboard: OpDashboard): DataProviderRequest<void> => {
        const promise = this.dataProvider
            .sendRequestWithSession("OpxDeleteOperatorDashboardConf", {
                IdOperator: idOperator,
                Dashboard: dashboard,
            }, null)

        return DataProviderRequest.fromJQuery(promise);
    }

    //#endregion

    //#region Get

    public getDashboardConf = (idOperator: number, idDashboard: number = null): DataProviderRequest<OpDashboard[]> => {
        const promise = this.dataProvider
            .sendRequestWithSession("OpxGetOperatorDashboardConf", { IdOperator: idOperator, IdDashboard: idDashboard }, 'OpxGetOperatorDashboardConfResult')
            .then((result: any[]) => {
                return _.map(result, (dashboardConfig: any) => {
                    return new OpDashboard(dashboardConfig)
                })
            })

        return DataProviderRequest.fromJQuery(promise)
    }

    public getDashboardData = (idOperator: number, idDashboard: number, idGroup: number, dashboardItemClass: Enums.DashboardItemClass, idTypes: number[]): DataProviderRequest<OpDashboardControl[]> => {
        const promise = this.dataProvider
            .sendRequestWithSession("OpxGetOperatorDashboardData", {
                IdOperator: idOperator,
                IdDashboard: idDashboard,
                IdGroup: idGroup,
                DashboardItemClass: dashboardItemClass,
                IdTypes: idTypes
            }, 'OpxGetOperatorDashboardDataResult')
            .then((result: any[]) => {
                return DashboardComponent.CreateDashboardControl(result)
            })

        return DataProviderRequest.fromJQuery(promise)
    }

    public getDashboardTemplate = (idOperator: number): DataProviderRequest<OpDashboard[]> => {
        const promise = this.dataProvider
            .sendRequestWithSession("OpxGetOperatorDashboardTemplate", { IdOperator: idOperator }, 'OpxGetOperatorDashboardTemplateResult')
            .then((result: any) => {
                return _.map(result, (dashboardConfig: any) => {
                    return new OpDashboard(dashboardConfig)
                })
            })

        return DataProviderRequest.fromJQuery(promise)
    }

    //#endregion

    //#region Export

    public exportOperatorDashboardData = (exportData: OpExportData, fileName: string = null): DataProviderRequest<OpFile> => {
        const promise = this.dataProvider
            .sendRequestWithSession("OpxExportOperatorDashboardData", {
                ExportData: exportData,
                FileName: fileName,
            }, "OpxExportOperatorDashboardDataResult")
            .then((data: any) => {
                if (data != null) {
                    return new OpFile(data)
                }

                return null
            })

        return DataProviderRequest.fromJQuery(promise)
    }

    //#endregion

    //#region Save

    public saveDashboardConf = (idOperator: number, dashboard: OpDashboard, destinationLevel: Enums.ReferenceType, idDestinationObject: any): DataProviderRequest<void> => {
        const promise = this.dataProvider
            .sendRequestWithSession("OpxSaveOperatorDashboardConf", {
                IdOperator: idOperator,
                Dashboard: dashboard.toJSON(),
                DestinationLevel: destinationLevel,
                IdDestinationObject: idDestinationObject,
            }, null)

        return DataProviderRequest.fromJQuery(promise);
    }

    //#endregion
}